import { handleActions } from "redux-actions";
import { produce } from "immer";
const initialState = {};

const slider = handleActions({}, initialState);

export default slider;
